<template>
    <div class="propertiesBox rounded-10 overflow-hidden mt-2">

        <b-button id="switch-settings" class="text-white w-100 text-left d-flex justify-content-between align-items-center py-2 border-0" variant="link" @click="setSidebarDropped('settings')" :class="[{'active': selectedShape && isSidebarDropped == 'settings'}, {'opa-5' : isSidebarDropped != 'settings' && !selectedShape}]">
            <div class="d-flex">
                <b-icon icon="sliders" font-scale="1" />
                <span class="ml-2 p-0"><t propertiesBox.settings /></span>
            </div>
            <b-icon icon="caret-down-fill" font-scale=".95" v-if="selectedShape" />
        </b-button>

        <div class="fly-over-tool animated slideInRight cursor-pointer" @click="$store.dispatch('setTuto', null); noShowTuto = true" v-if="tutoEditor == 'settings' && noShowTuto == false">
            <div class="bg-rose rounded-left-10 p-3 shadow-pro text-left">
                <span class="text-white h5 font-weight-bold"><t propertiesBox.tutoTitle /></span>
                <p class="text-white mb-0 line-height"><t propertiesBox.tutoText /></p>
            </div>
        </div>

        <transition name="bounce">
            <div id="settings-sidebar" class="bg-gris-pro rounded-bottom-10"  v-if="selectedShape && isSidebarDropped == 'settings'">
                <div class="py-3">
                    <transition-group name="bounce">
                        <div id="main-setting" class="mx-3 mb-2 bg-white rounded-10" key="main">
                            <transition-group name="bounce">
                                <!-- Redimensionner -->
                                <div id="resize" class="px-2 py-2 position-relative" :class="{'tuto' : tutoEditor == 'settings' && noShowTuto == false}" v-if="selectedShape.accepts('resize', 'resize-radius')" key="resize">

                                    <span class="d-flex align-items-center mt-1 px-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-7 -7 230 230" height="20px">
                                            <path class="cls-1" d="M219.15,152.47h9.7a2.64,2.64,0,0,0,2.65-2.64V71.15a2.64,2.64,0,0,0-2.65-2.65h-78.7a2.64,2.64,0,0,0-2.65,2.65v9.7a2.64,2.64,0,0,0,2.65,2.65h55.74L144.1,145.3a2.63,2.63,0,0,0,0,3.74L151,155.9a2.63,2.63,0,0,0,3.74,0l61.8-61.79v55.72A2.64,2.64,0,0,0,219.15,152.47Z" transform="translate(-15 -68.5)"/>
                                            <path class="cls-2" d="M17.65,285h78.7A2.64,2.64,0,0,0,99,282.35v-9.7A2.64,2.64,0,0,0,96.35,270H40.61l61.82-61.83a2.63,2.63,0,0,0,0-3.74l-6.86-6.86a2.63,2.63,0,0,0-3.74,0L30,259.39V203.65A2.64,2.64,0,0,0,27.35,201h-9.7A2.64,2.64,0,0,0,15,203.65v78.7A2.64,2.64,0,0,0,17.65,285Z" transform="translate(-15 -68.5)"/>
                                        </svg>
                                        <t class="ml-1 font-weight-bold" propertiesBox.size v-if="!selectedShape.accepts('resize-radius')" />
                                        <t class="ml-1 font-weight-bold" propertiesBox.radius v-else />
                                        <b-icon class="ml-2" icon="info-circle-fill" font-scale=".9" @click="tutorial('resize')" />
                                    </span>
                                    <transition-group name="bounce">
                                        <div class="fly-over-setting my-2 mx-1 position-relative" v-if="tuto == 'resize'" key="tuto" @click="tuto = null">
                                            <div class="bg-gris-pro rounded-10 px-3 py-2 text-left">
                                                <p class="text-dark mb-0 line-height">
                                                    <t propertiesBox.tutoResize v-if="!selectedShape.accepts('resize-radius')" />
                                                    <t propertiesBox.tutoResizeRadiusSmall v-else-if="drillingDiameters.length > 0 && radius < cuttingOptions.drillingThresholdDiameter/2 "/>
                                                    <t propertiesBox.tutoResizeRadius v-else />
                                                </p>
                                            </div>
                                        </div>
                                    </transition-group>
                                    <div class="d-flex mt-2 px-1 pb-1" v-if="selectedShape.accepts('resize')">
                                        <div class="mr-1">
                                            <div class="w-100 position-relative input-number">
                                                <input type="number" v-model="width" @input="updateSize" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                                <span class="suffix-detail" v-if="width"><span>{{width}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                                <span class="indicator"><t propertiesBox.l /></span>
                                            </div>
                                        </div>
                                        <div class="ml-1">
                                            <div class="w-100 position-relative input-number">
                                                <input type="number" class="rounded-10" v-model="height" @input="updateSize" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                                <span class="suffix-detail" v-if="height"><span>{{height}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                                <span class="indicator"><t propertiesBox.h /></span>
                                            </div>
                                        </div>
                                        <div class="checkbox mt-1" v-if="keepProportions != null">
                                            <input type="checkbox" id="keepProportions" name="keepProportions" v-model="keepProportions" :checked="keepProportions"  @change="updateKeepProportions" @click="textFocus" @blur="textBlur" >
                                            <label class="cursor-pointer mb-0" for="keepProportions"><t propertiesBox.keepProportions /></label>
                                        </div>
                                    </div>
                                    <div class="mt-2 px-1 pb-1" v-if="selectedShape.accepts('resize-radius')">
                                        <div class="w-100">
                                            <select v-if="drillingDiameters.length > 0 && radius < cuttingOptions.drillingThresholdDiameter/2 " @change="updateRadius('select')" v-model="diameter">
                                                <option v-for="limits in drillingDiameters" :value="limits" :key="limits">{{limits}} mm</option>
                                                <option :value="cuttingOptions.drillingThresholdDiameter" :key="cuttingOptions.drillingThresholdDiameter">>{{cuttingOptions.drillingThresholdDiameter}} mm</option>
                                            </select>
                                            <div class="w-100 position-relative input-number" v-if="radius >= cuttingOptions.drillingThresholdDiameter/2">
                                                <input id="switchUpFocus"  type="number" step="0,01" v-model="diameter" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus(), updateRadius()"  @input="updateRadius"/>
                                                <span class="suffix-detail" v-if="radius"><span>{{diameter}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                                <div id="radius-resize" class="indicator h-100 d-flex">
                                                    <span class="h-100 d-flex align-items-center mr-2"><t propertiesBox.r /></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="py-2 position-relative d-flex small justify-content-end" key="switch-centerMarking" v-if="selectedShape.accepts('resize-radius') && materialName == 'Metal'">
                                            <div>
                                                <b-form-checkbox switch v-model="selectedShape.centerMarking" @change="switchMarkingCenter(selectedShape)" />
                                            </div>
                                            <div class="d-flex align-items-center justify-content-center position-relative">
                                                <span class="text-dark font-weight-bold"><t propertiesBox.changeInAiming /></span>
                                            </div>
                                        </div>
                                        <transition-group name="bounce">
                                            <div id="alertRadius" class="rounded-10 p-2 mt-2 font-weight-bold small" v-if="alertRadius" key="alertRadius">
                                                <t class="text-rose" propertiesBox.alertRadiusTitle />
                                                <b-icon icon="info-circle-fill" font-scale="1.2" />
                                                <div>
                                                    <t propertiesBox.alertRadius /> {{cuttingOptions.drillingThresholdDiameter}} <t propertiesBox.mm />
                                                </div>
                                            </div>
                                        </transition-group>
                                    </div>
                                </div>

                                <!-- Position -->
                                <div id="move" class="px-2 py-2 position-relative" :class="{'tuto' : tutoEditor == 'settings' && noShowTuto == false}" v-if="selectedShape.accepts('move') && !selectedShape.isOrigin && selectedShape.isCut" key="move">
                                    <span class="d-flex align-items-center mt-1 px-1">
                                        <b-icon icon="arrows-move" class="cursor-pointer" font-scale="1.5" />
                                        <t class="ml-1 font-weight-bold" propertiesBox.position />
                                        <b-icon class="ml-2" icon="info-circle-fill" font-scale=".9" @click="tutorial('move')" />
                                    </span>
                                    <transition-group name="bounce">
                                        <div class="fly-over-setting my-2 mx-1 position-relative" v-if="tuto == 'move'" key="tuto" @click="tuto = null">
                                            <div class="bg-gris-pro rounded-10 px-3 py-2 text-left">
                                                <p class="text-dark mb-0 line-height"><t propertiesBox.tutoMove /></p>
                                            </div>
                                        </div>
                                    </transition-group>
                                    <div class="d-flex mt-2 px-1 pb-1">
                                        <div class="mr-1">
                                            <div class="w-100 position-relative input-number">
                                                <input type="number" v-model="positionX" @input="updatePosition" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                                <span class="suffix-detail" v-if="positionX"><span>{{positionX}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                                <span class="indicator"><t propertiesBox.x /></span>
                                            </div>
                                        </div>
                                        <div class="ml-1">
                                            <div class="w-100 position-relative input-number">
                                                <input type="number" v-model="positionY" @input="updatePosition" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                                <span class="suffix-detail" v-if="positionY"><span>{{positionY}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                                <span class="indicator"><t propertiesBox.y /></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Rotation -->
                                <div id="rotate" class="px-2 py-2 position-relative" v-if="selectedShape.accepts('rotate')" key="rotate">
                                    <span class="d-flex align-items-center mt-1 px-1">
                                        <svg class="rotate" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.9 18" width="20px">
                                            <path d="M18.36,5.64a9,9,0,0,0-12.73,0,9.08,9.08,0,0,0-2.46,4.6l-.36-.36a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l2.12,2.12a1,1,0,0,0,1.42,0h0l2.12-2.12A1,1,0,0,0,5.64,9.88h0l-.42.42A7,7,0,1,1,7.05,17a1,1,0,0,0-1.41,1.41A9,9,0,0,0,18.36,5.64Z" transform="translate(-1.1 -3)" fill="#343a40"/>
                                        </svg>
                                        <t class="ml-1 font-weight-bold" propertiesBox.rotation />
                                        <b-icon class="ml-2" icon="info-circle-fill" font-scale=".9"  @click="tutorial('rotate')" />
                                    </span>
                                    <transition-group name="bounce">
                                        <div class="fly-over-setting my-2 mx-1 position-relative" v-if="tuto == 'rotate'" key="tuto" @click="tuto = null">
                                            <div class="bg-gris-pro rounded-10 px-3 py-2 text-left">
                                                <p class="text-dark mb-0 line-height"><t propertiesBox.tutoRotate /></p>
                                            </div>
                                        </div>
                                    </transition-group>
                                    <div class="d-flex px-1 pb-1 align-items-center">
                                        <vue-slider class="col-8"
                                            v-model="rotation"
                                            :min="-180"
                                            :max="180"
                                            :tooltip="'none'"
                                            :contained="true"
                                            :interval="1"
                                            @change="updateRotation"
                                            @drag-start="preventRepaint"
                                            @drag-end="allowRepaint"
                                        />
                                        <div class="col-4 pl-0 position-relative input-number">
                                            <input type="number" class="w-100" v-model="rotation" @input="updateRotation" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                            <span class="suffix-detail degrees" v-if="rotation || rotation == 0"><span>{{rotation}}</span> <span class="suffix"><t propertiesBox.degrees /></span></span>
                                        </div>
                                    </div>
                                </div>
                            </transition-group>
                        </div>
                    </transition-group>

                    <transition-group name="bounce">
                        <div id="alternative-setting" class="mx-3 mt-2 bg-white rounded-10" key="alternative">
                            <transition-group name="bounce">

                                <!-- Texte -->
                                <div id="text" class="p-2 position-relative" v-if="selectedShape.accepts('text')" key="text">
                                    <span class="d-flex align-items-center mt-1 px-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 151.21 151.21" height="26px">
                                            <text class="text-1" x="47" y="112" font-family="Raleway" font-size="100">T</text>
                                            <text class="text-2" x="42" y="112" font-family="Ubuntu" font-size="100" style="opacity: 0">R</text>
                                            <text class="text-3" x="46" y="105" font-family="Open Sans" font-size="100" style="opacity: 0">u</text>
                                            <path class="cls-2" d="M209.43,373.36H110.68a1.54,1.54,0,0,1-1.54-1.55V361H98.34a1.54,1.54,0,0,1-1.54-1.54V260.72a1.54,1.54,0,0,1,1.54-1.54h10.8v-10.8a1.54,1.54,0,0,1,1.54-1.54h98.75a1.54,1.54,0,0,1,1.54,1.54v10.8h10.8a1.54,1.54,0,0,1,1.55,1.54v98.75a1.54,1.54,0,0,1-1.55,1.54H211v10.8A1.54,1.54,0,0,1,209.43,373.36Zm-97.2-3.09h95.66v-10.8a1.54,1.54,0,0,1,1.54-1.54h10.8V262.26h-10.8a1.54,1.54,0,0,1-1.54-1.54v-10.8H112.23v10.8a1.55,1.55,0,0,1-1.55,1.54H99.88v95.67h10.8a1.55,1.55,0,0,1,1.55,1.54Z" transform="translate(-84.45 -234.49)"/>
                                            <path class="cls-2" d="M110.68,262.26H86a1.54,1.54,0,0,1-1.55-1.54V236A1.54,1.54,0,0,1,86,234.49h24.68a1.55,1.55,0,0,1,1.55,1.54v24.69A1.55,1.55,0,0,1,110.68,262.26Zm-23.14-3.08h21.6v-21.6H87.54Z" transform="translate(-84.45 -234.49)"/>
                                            <path class="cls-2" d="M234.12,262.26H209.43a1.54,1.54,0,0,1-1.54-1.54V236a1.54,1.54,0,0,1,1.54-1.54h24.69a1.54,1.54,0,0,1,1.54,1.54v24.69A1.54,1.54,0,0,1,234.12,262.26ZM211,259.18h21.6v-21.6H211Z" transform="translate(-84.45 -234.49)"/>
                                            <path class="cls-2" d="M110.68,385.7H86a1.54,1.54,0,0,1-1.55-1.54V359.47A1.54,1.54,0,0,1,86,357.93h24.68a1.55,1.55,0,0,1,1.55,1.54v24.69A1.55,1.55,0,0,1,110.68,385.7Zm-23.14-3.09h21.6V361H87.54Z" transform="translate(-84.45 -234.49)"/>
                                            <path class="cls-2" d="M234.12,385.7H209.43a1.54,1.54,0,0,1-1.54-1.54V359.47a1.54,1.54,0,0,1,1.54-1.54h24.69a1.54,1.54,0,0,1,1.54,1.54v24.69A1.54,1.54,0,0,1,234.12,385.7ZM211,382.61h21.6V361H211Z" transform="translate(-84.45 -234.49)"/>
                                        </svg>
                                        <t class="ml-1 font-weight-bold" propertiesBox.text />
                                    </span>

                                    <div class="d-flex mt-2 px-1 pb-1">
                                        <div class="w-100">
                                            <div class="w-100 position-relative mt-2" v-if="availableFonts.length > 1">
                                                <span class="font-weight-bold d-block"><t propertiesBox.font /></span>
                                                <v-select class="toplevel bg-white rounded-10" :value="propFontName" :reduce="font => font.name" label="name" :options="availableFonts" :clearable="false" @input="updateFont">
                                                    <template slot="option" slot-scope="option" class="rounded-10">
                                                        <svg height="1.7em" viewBox="-20 -20 1000 150" v-html="option.sample" />
                                                    </template>
                                                </v-select>
                                            </div>

                                            <div class="w-100 position-relative mt-2">
                                                <span class="font-weight-bold d-block"><t propertiesBox.content /></span>
                                                <div class="d-flex">
                                                    <input class="w-100 rounded-left-10 border-right-0 font-weight-normal" v-model="content" @click="textFocus" @blur="textBlur" v-on:keyup.enter="updateContent()" />
                                                    <button class="rounded-right-10 btn-ok bg-jaune border-0 px-2 text-uppercase font-weight-bold text-white" v-on:click="updateContent()"><t propertiesBox.ok /></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Coins arrondis -->
                                <div id="round-corners" v-if="selectedShape.accepts('round-corners') && !this.multipleCorner" class="px-2 pt-2 pb-0 position-relative" key="corners">
                                    <div class="w-100 position-relative">
                                        <span class="d-flex align-items-center mt-1 px-1">
                                            <div id="rect" class="rect"></div>
                                            <t class="ml-1 font-weight-bold" propertiesBox.roundedCorner />
                                            <b-icon class="ml-2" icon="info-circle-fill" font-scale=".9" @click="tutorial('corners')" />
                                        </span>
                                        <transition-group name="bounce">
                                            <div class="fly-over-setting my-2 mx-1 position-relative" v-if="tuto == 'corners'" key="tuto" @click="tuto = null">
                                                <div class="bg-gris-pro rounded-10 px-3 py-2 text-left">
                                                    <p class="text-dark mb-0 line-height"><t propertiesBox.tutoRoundCorner /></p>
                                                </div>
                                            </div>
                                        </transition-group>
                                        <div class="d-flex align-items-center px-1">
                                            <vue-slider
                                                class="col-8"
                                                v-model="corner"
                                                :min="0"
                                                :max="maxCorner"
                                                :tooltip="'none'"
                                                :contained="true"
                                                :interval="0.1"
                                                @change="updateCorner"
                                                @drag-start="preventRepaint"
                                                @drag-end="allowRepaint"
                                            />
                                            <div class="position-relative input-number col-4 pl-0">
                                                <input type="number" class="w-100" v-model="corner" @input="updateCorner" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                                <span class="suffix-detail" v-if="corner || corner == 0"><span>{{corner}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="round-corners-advanced" key="round-corners-advanced" v-if="selectedShape.accepts('round-corners') && this.multipleCorner">
                                    <div class="px-2 pt-2 position-relative" >
                                        <div class="w-100 position-relative">
                                            <span class="d-flex align-items-center mt-1 px-1">
                                                <div id="rect-top-left" class="rect"></div>
                                                <t class="ml-1 font-weight-bold" propertiesBox.roundedCornerTopLeft />
                                            </span>
                                            <div class="d-flex align-items-center px-1">
                                                <vue-slider
                                                    class="col-8"
                                                    v-model="cornerTopLeft"
                                                    :min="0"
                                                    :max="Math.round(maxCorner)"
                                                    :tooltip="'none'"
                                                    :contained="true"
                                                    :interval="1"
                                                    @change="updateRoundCorner"
                                                    @drag-start="preventRepaint"
                                                    @drag-end="allowRepaint"
                                                />
                                                <div class="position-relative input-number col-4 pl-0">
                                                    <input type="number" class="w-100" v-model="cornerTopLeft" @input="updateRoundCorner" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()"/>
                                                    <span class="suffix-detail" v-if="cornerTopLeft || cornerTopLeft == 0"><span>{{cornerTopLeft}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="px-2 position-relative">
                                        <div class="w-100 position-relative">
                                            <span class="d-flex align-items-center mt-1 px-1">
                                                <div id="rect-top-right" class="rect"></div>
                                                <t class="ml-1 font-weight-bold" propertiesBox.roundedCornerTopRight />
                                            </span>
                                            <div class="d-flex align-items-center px-1">
                                                <vue-slider
                                                    class="col-8"
                                                    v-model="cornerTopRight"
                                                    :min="0"
                                                    :max="Math.round(maxCorner)"
                                                    :tooltip="'none'"
                                                    :contained="true"
                                                    :interval="1"
                                                    @change="updateRoundCorner"
                                                    @drag-start="preventRepaint"
                                                    @drag-end="allowRepaint"
                                                />
                                                <div class="position-relative input-number col-4 pl-0">
                                                    <input type="number" class="w-100" v-model="cornerTopRight" @input="updateRoundCorner" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                                    <span class="suffix-detail" v-if="cornerTopRight || cornerTopRight == 0"><span>{{cornerTopRight}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="px-2 position-relative">
                                        <div class="w-100 position-relative">
                                            <span class="d-flex align-items-center mt-1 px-1">
                                                <div id="rect-bottom-left" class="rect"></div>
                                                <t class="ml-1 font-weight-bold" propertiesBox.roundedCornerBottomLeft />
                                            </span>
                                            <div class="d-flex align-items-center px-1">
                                                <vue-slider
                                                    class="col-8"
                                                    v-model="cornerBottomLeft"
                                                    :min="0"
                                                    :max="Math.round(maxCorner)"
                                                    :tooltip="'none'"
                                                    :contained="true"
                                                    :interval="1"
                                                    @change="updateRoundCorner"
                                                    @drag-start="preventRepaint"
                                                    @drag-end="allowRepaint"
                                                />
                                                <div class="position-relative input-number col-4 pl-0">
                                                    <input type="number" class="w-100" v-model="cornerBottomLeft" @input="updateRoundCorner" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                                    <span class="suffix-detail" v-if="cornerBottomLeft || cornerBottomLeft == 0"><span>{{cornerBottomLeft}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="px-2 pb-0 position-relative">
                                        <div class="w-100 position-relative">
                                            <span class="d-flex align-items-center mt-1 px-1">
                                                <div id="rect-bottom-right" class="rect"></div>
                                                <t class="ml-1 font-weight-bold" propertiesBox.roundedCornerBottomRight />
                                            </span>
                                            <div class="d-flex align-items-center px-1">
                                                <vue-slider
                                                    class="col-8"
                                                    v-model="cornerBottomRight"
                                                    :min="0"
                                                    :max="Math.round(maxCorner)"
                                                    :tooltip="'none'"
                                                    :contained="true"
                                                    :interval="1"
                                                    @change="updateRoundCorner"
                                                    @drag-start="preventRepaint"
                                                    @drag-end="allowRepaint"
                                                />
                                                <div class="position-relative input-number col-4 pl-0">
                                                    <input type="number" class="w-100" v-model="cornerBottomRight" @input="updateRoundCorner" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                                    <span class="suffix-detail" v-if="cornerBottomRight || cornerBottomRight == 0"><span>{{cornerBottomRight}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="pr-3 py-2 position-relative d-flex small justify-content-end" key="switch-corners" v-if="selectedShape.accepts('round-corners')">
                                    <div>
                                        <b-form-checkbox switch v-model="multipleCorner" @change="switchCorner" />
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center position-relative">
                                        <span class="text-dark font-weight-bold"><t propertiesBox.advancedCorner /></span>
                                    </div>
                                </div>

                                <!-- Triangle -->
                                <div id="triangle" v-if="selectedShape.accepts('triangle')" class="px-2 p-2 position-relative" key="triangle">
                                    <div class="w-100 position-relative">
                                        <div class="d-flex align-items-center mt-1 px-1">
                                            <span class="d-flex align-items-center mt-1">
                                                <svg id="shape" xmlns="http://www.w3.org/2000/svg" viewBox="-1 -2 153.68 114" height="20px" restart="never">
                                                    <polygon class="cls-1" points="43.16 11.75 147.87 109.5 2.25 109.5 43.16 11.75" fill="white" stroke="#343a40" stroke-width="6">
                                                        <animate begin="shape.mouseover" end="shape.mouseleave" attributeName="points" fill="remove" dur=".8s" to="2 11.75 147.87 109.5 2.25 109.5 2 11.75" repeatCount="indefinite" />
                                                    </polygon>
                                                    <line class="cls-2" x1="45.82" y1="108.29" x2="44.26" y2="11.48" fill="white" stroke="#343a40" stroke-width="6" stroke-dasharray="10">
                                                        <animate begin="shape.mouseover" end="shape.mouseleave" attributeName="x1" fill="remove" dur=".8s" to="0" repeatCount="indefinite" />
                                                        <animate begin="shape.mouseover" end="shape.mouseleave" attributeName="x2" fill="remove" dur=".8s" to="0" repeatCount="indefinite" />
                                                    </line>
                                                    <circle class="cls-1" cx="44.26" cy="11.75" r="10.24" fill="white" stroke="#343a40" stroke-width="6">
                                                        <animate begin="shape.mouseover" end="shape.mouseleave" attributeName="cx" fill="remove" dur=".8s" to="1" repeatCount="indefinite" />
                                                    </circle>
                                                </svg>
                                                <t class="ml-1 font-weight-bold" propertiesBox.topPosition />
                                                <b-icon class="ml-2" icon="info-circle-fill" font-scale=".9" @click="tutorial('triangle')" />
                                            </span>
                                        </div>
                                        <transition-group name="bounce">
                                            <div class="fly-over-setting my-2 mx-1 position-relative" v-if="tuto == 'triangle'" key="tuto" @click="tuto = null">
                                                <div class="bg-gris-pro rounded-10 px-3 py-2 text-left">
                                                    <p class="text-dark mb-0 line-height"><t propertiesBox.tutoTriangle /></p>
                                                </div>
                                            </div>
                                        </transition-group>
                                        <div class="d-flex align-items-center mt-2 px-1">
                                            <vue-slider
                                                class="col-8"
                                                v-model="heightPos"
                                                :min="0"
                                                :max="Math.ceil(width)"
                                                :tooltip="'none'"
                                                :contained="true"
                                                :interval="1"
                                                @change="updateHeightPos"
                                                @drag-start="preventRepaint"
                                                @drag-end="allowRepaint"
                                            />
                                            <div class="position-relative col-4 pl-0 input-number">
                                                <input type="number" v-model="heightPos" @input="updateHeightPos" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                                <span class="suffix-detail" v-if="heightPos || heightPos == 0"><span>{{heightPos}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition-group>
                        </div>
                    </transition-group>

                    <!-- Choix de forme -->
                    <div id="button-setting" v-if="selectedShape.accepts('pockets') || selectedShape.accepts('svg')">
                        <transition-group name="bounce" class="d-flex mx-3">

                            <div id="shape" variant="link" class="bg-white py-2 rounded-10 d-flex flex-column align-items-center justify-content-center w-100" v-if="selectedShape.accepts('svg')" key="shape">
                                <div class="d-flex align-items-center justify-content-between w-100 px-2">
                                    <div class="d-flex ml-1">
                                        <svg v-if="icon" height="20px" :viewBox="'-2 ' + '-2 ' + icon.xmax * 1.1 + ' ' + icon.ymax * 1.1">
                                            <path :d="icon.path"></path>
                                        </svg>
                                        <span class="font-weight-bold ml-1 text-capitalize">{{icon.name}}</span>
                                    </div>
                                    <span class="text-dark font-weight-bold small rounded-10 bg-gris-pro cursor-pointer py-1 px-2 mr-1" @click="openIconsModal"><t propertiesBox.changeIcons /></span>
                                </div>
                            </div>

                            <!-- Poches -->
                            <div id="pockets" variant="link" class="bg-white rounded-10 w-100 p-2 mt-2" v-if="selectedShape.accepts('pockets')" key="pockets">
                                <div class="d-flex justify-content-between">
                                    <div class="mx-1 d-flex align-items-center justify-content-center position-relative">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 -3 100.9 100.9" height="20px">
                                            <rect class="cls-1" x="5.4" y="5.4" width="84.1" height="84.1" fill="white" stroke="#343a40" stroke-width="6" />
                                            <circle class="cls-1" cx="8.5" cy="8.5" r="7.9" fill="white" stroke="#343a40" stroke-width="6"/>
                                            <circle class="cls-1" cx="8.4" cy="86.5" r="7.9" fill="white" stroke="#343a40" stroke-width="6"/>
                                            <circle class="cls-1" cx="86.5" cy="86.5" r="7.9" fill="white" stroke="#343a40" stroke-width="6"/>
                                            <circle class="cls-1" cx="86.5" cy="8.4" r="7.9" fill="white" stroke="#343a40" stroke-width="6"/>
                                            <rect x="8.9" y="8.9" width="16" height="16" fill="white" class="cls-2"></rect>
                                            <rect x="70" y="8.9" width="16" height="16" fill="white" class="cls-2"></rect>
                                            <rect x="70" y="70" width="16" height="16" fill="white" class="cls-2"></rect>
                                            <rect x="9" y="70" width="16" height="16" fill="white" class="cls-2"></rect>
                                        </svg>
                                        <span class="text-dark font-weight-bold ml-1"><t propertiesBox.pockets /></span>
                                        <b-icon class="ml-2" icon="info-circle-fill" font-scale=".9" @click="tutorial('pockets')" />
                                    </div>
                                    <div>
                                        <b-form-checkbox switch v-model="pockets" @change="updatePockets" />
                                    </div>
                                </div>
                                <transition-group name="bounce" tag="div">
                                    <div class="fly-over-setting mt-2 position-relative" v-if="tuto == 'pockets'" key="tuto" @click="tuto = null">
                                        <div class="bg-gris-pro rounded-10 px-3 py-2 text-left">
                                            <p class="text-dark mb-0 line-height"><t propertiesBox.tutoPockets /></p>
                                        </div>
                                    </div>
                                </transition-group>
                            </div>
                        </transition-group>
                    </div>

                    <!-- Actions -->
                    <div id="action-setting" class="bg-white mx-3 mt-3 rounded-10 pb-1">
                        <div class="d-flex flex-wrap align-items-center justify-content-around">
                            <div id="remove" class="d-flex flex-column align-items-center justify-content-center mx-1 rounded-10 p-2 cursor-pointer tool position-relative" :class="selectedShape.locked || this.notCuttable ? 'disabled': ''">
                                <svg class="animated swing" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -10 171.76 200.08" width="23px" @click="removeShape(selectedShape)">
                                    <rect class="cls-1" x="50.89" y="1.5" width="63.8" height="34.07" rx="5.6" fill="#e7e7e7" stroke="#343a40" stroke-width="10" />
                                    <line class="cls-2" x1="64.38" y1="83.13" x2="64.38" y2="153.08" stroke="#343a40" stroke-width="10" stroke-linecap="5"  />
                                    <line class="cls-2" x1="100.38" y1="82.98" x2="100.38" y2="152.93" fill="#343a40" stroke="#343a40" stroke-width="10"/>
                                    <path class="cls-3" d="M202,237.65l13.2-127.39a8.36,8.36,0,0,0-8.33-9.22H93.48a8.37,8.37,0,0,0-8.32,9.29L99.39,237.45a8.37,8.37,0,0,0,8.29,7.44l85.95.26A8.36,8.36,0,0,0,202,237.65Z" transform="translate(-67.62 -57.57)" fill="transparent" stroke="#343a40" stroke-width="10" />
                                    <rect class="cls-1" x="1.5" y="26.79" width="161.76" height="24" rx="4.87" fill="#e7e7e7" stroke="#343a40" stroke-width="10" stroke-miterlimit="10"/>
                                </svg>
                                <div class="fly-over">
                                    <t propertiesBox.delete />
                                </div>
                            </div>
                            <div id="lock" class="d-flex flex-column align-items-center justify-content-center mx-1 rounded-10 p-2 cursor-pointer tool position-relative">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -15 180.98 220" @click="lockShape(selectedShape)" :class="selectedShape.locked ? 'locked' : 'unlocked'" width="20px">
                                    <path class="cls-1" d="M193.7,179.36V96a42.82,42.82,0,0,0-42.82-42.82h-1.79A42.83,42.83,0,0,0,106.26,96l.16,30.08" transform="translate(-63.54 -51.21)" fill="transparent" stroke="#343a40" stroke-width="10" />
                                    <path d="M106.42,126.11" transform="translate(-63.54 -51.21)" fill="transparent" stroke="#343a40" stroke-width="10"/>
                                    <path d="M193.54,76.49" transform="translate(-63.54 -51.21)"/>
                                    <path d="M193.54,126.11" transform="translate(-63.54 -51.21)"/>
                                    <rect x="2" y="74.9" width="168.98" height="132.88" rx="8.55" fill="#343a40" stroke="#343a40" stroke-width="10" />
                                    <circle cx="86.46" cy="132.57" r="13.6" fill="white" />
                                    <path d="M158.62,193.28v20.43a8.67,8.67,0,0,1-8.64,8.7h0a8.67,8.67,0,0,1-8.63-8.7V193.28" transform="translate(-63.54 -51.21)" fill="white" />
                                </svg>
                                <div class="fly-over">
                                    <t propertiesBox.lock />
                                </div>
                            </div>
                            <div id="clone" class="d-flex flex-column align-items-center justify-content-center mx-1 rounded-10 p-2 cursor-pointer tool position-relative" :class="selectedShape.locked ? 'disabled': ''">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -14 101.67 109.14" width="32px" @click="cloneShape(selectedShape)">
                                    <rect class="cls-1" x="19.68" y="-4.5" width="68.49" height="68.49" rx="11.3" fill="white" stroke="#343a40" stroke-width="4" stroke-dasharray="5" />
                                    <rect class="cls-2" x="5.5" y="10.15" width="68.49" height="68.49" rx="11.3" fill="white" stroke="#343a40" stroke-width="4" />
                                </svg>
                                <div class="fly-over">
                                    <t propertiesBox.duplicate />
                                </div>
                            </div>
                            <div id="recenter" class="d-flex flex-column align-items-center justify-content-center mx-1 rounded-10 p-2 cursor-pointer tool position-relative">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="10 -15 105.47 107.83" @click="centerOrigin()" width="27px">
                                    <rect class="cls-1" x="25.04" y="-3.5" width="84.93" height="84.93" rx="15" fill="white" stroke="#343a40" stroke-width="5" />
                                    <line class="cls-2" x1="11.17" y1="34.66" x2="11.17" y2="94.31" stroke="#7ebb49" stroke-width="10px"/>
                                    <polygon class="cls-3" points="11.78 35.26 10.55 35.26 11.17 34.2 11.78 35.26" stroke="#7ebb49" stroke-width="10px"/>
                                    <line class="cls-4" x1="69.32" y1="94.31" x2="8.67" y2="94.31" stroke="#df1517" stroke-width="10px" />
                                    <polygon class="cls-5" points="68.48 94.92 68.48 93.69 69.78 94.31 68.48 94.92" stroke="#df1517" stroke-width="10px" />
                                </svg>
                                <div class="fly-over">
                                    <t propertiesBox.recenter />
                                </div>
                            </div>
                        </div>
                        <transition-group name="bounce">
                            <div id="not-cuttable" class="fly-over-setting my-2 px-2 position-relative w-100" v-if="this.notCuttable" key="tuto" @click="tuto = null">
                                <div class="bg-gris-pro rounded-10 px-3 py-2 text-left">
                                        <p class="text-dark mb-0 line-height">
                                        <t propertiesBox.notCuttable />
                                    </p>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                </div>
            </div>
        </transition>

        <transition-group name="bounce" tag="div">
            <div class="fly-over-setting mt-2 position-relative" v-if="tuto == 'settings'" key="tuto" @click="tuto = null">
                <div class="bg-gris-pro rounded-10 px-3 py-2 text-left">
                    <p class="text-dark mb-0"><t propertiesBox.pieceNotSelected /></p>
                </div>
            </div>
        </transition-group>

        <b-modal id="icons-modal" ref="icons-modal" size="xl" hide-footer centered scrollable modal-class="bg-transparent" body-class="p-0 d-flex bg-transparent" content-class="bg-transparent border-0" v-model="iconModal">
            <div class="col-4 bg-rose rounded-10 d-flex justify-content-between flex-column py-5">
                <div>
                    <h3 class="text-white text-center font-weight-bold h2 line-height pb-3"><t propertiesBox.categories /></h3>
                    <div id="category-choice">
                        <div id="category">
                            <div
                            v-for="category in categories"
                            v-bind:key="category"
                            @click="selectedCategory = category"
                            class="d-flex align-items-center justify-content-center cursor-pointer mb-2 one-category">
                                <span class="h5 font-weight-normal text-white mb-0 text-capitalize" :class="{'active' : selectedCategory == category}">
                                    {{category}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="text-underline text-white text-center mt-4 cursor-pointer" @click="hideModal()"><t propertiesBox.hideIcons /></span>
            </div>
            <div class="col-8 pl-2 pr-0 bg-white my-2 rounded-right-10">
                <div class="icons py-2 pr-2">
                    <b-button
                        variant="light"
                        class="icon col-2 m-0 p-1 border-0"
                        v-for="icon in iconsOfCategory"
                        @click="selectIcon(icon)"
                        v-bind:key="icon.name">
                        <div class="icon-svg p-3">
                            <svg height="3em" :viewBox="icon.xmin + ' ' + icon.ymin + ' ' + icon.xmax + ' ' + icon.ymax">
                                <path :d="icon.path"></path>
                            </svg>
                        </div>
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import vSelect from 'vue-select'
import { models } from 'feathers-vuex';
import { paper, Point } from 'paper';
import { VBModal, BButton, BCol, BBadge, BListGroupItem, BListGroup, BRow, BContainer, BModal, BIcon, BIconSliders, BFormCheckbox, BIconTrashFill, BIconLockFill, BIconUnlockFill, BIconBack, BIconArrowsMove, BIconArrowsAngleExpand, BIconSubtract, BIconBootstrapReboot, BIconSquare, BIconCaretDownFill, BIconInfoCircleFill, BIconKeyboard, BIconTextareaT } from 'bootstrap-vue';
import { mapGetters, mapActions } from 'vuex';
import PathUtils from '@/services/PathUtils';
import ToolsUtils from '@/services/ToolsUtils'
import debounce from 'debounce';

export default {
    /* eslint-disable vue/no-unused-components */
    components: {
        VueSlider,
        vSelect,
        BButton,
        BCol,
        BBadge,
        BListGroupItem,
        BListGroup,
        BRow,
        BContainer,
        BModal,
        BIcon,
        BIconSliders,
        BFormCheckbox,
        BIconTrashFill,
        BIconLockFill,
        BIconUnlockFill,
        BIconBack,
        BIconArrowsMove,
        BIconArrowsAngleExpand,
        BIconSubtract,
        BIconBootstrapReboot,
        BIconSquare,
        BIconCaretDownFill,
        BIconInfoCircleFill,
        BIconKeyboard,
        BIconTextareaT
    },
    directives: {
        'b-modal': VBModal },
    data() {
        return {
            shapeId: null,
            corner : null,
            rotation: null,
            width: null,
            height: null,
            centerx: null,
            centery: null,
            content: null,
            autoSize: null,
            fontSize: null,
            radius: null,
            fonts: null,
            pockets: null,
            icons: [],
            iconName: null,
            keepProportions: null,
            selectedCategory: 'all',
            isOrigin: null,
            positionX: null,
            positionY: null,
            heightPos: null,
            oldTool: null,
            tuto: null,
            iconModal: null,
            notCuttable: false,
            noShowTuto: false,
            titles: {
                materialrectangle: "Rectangle",
                cutrectangle: "Découpe en rectangle",
                materialcircle: "Cercle",
                cutcircle: "Découpe en cercle",
                materialtext: "Texte",
                cuttext: "Découpe de texte",
                imported: "Forme importée",
                materialsvg: "Forme",
                cutsvg: "Découpe de forme",
                materialtriangle: "Triangle",
                cuttriangle: "Découpe en triangle"
            },
            diameter : this.radius*2,
            alertRadius: false,
            cornerBottomLeft: 0,
            cornerBottomRight : 0,
            cornerTopRight : 0,
            cornerTopLeft : 0,
            multipleCorner : null,
            centerMarking : false
        } 
    },

    async mounted() {
        this.fonts = this.refreshFonts();
        this.icons = this.refreshIcons();

        this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
            if (modalId == 'icons-modal') {
                this.$store.dispatch('openIconsChoice', false);
            }
        });
    },

    computed: {
        ...mapGetters([
            'propRadius',
            'propRotation',
            'propCorner',
            'propPockets',
            'propPosition',
            'propSize',
            'propKeepProportions',
            'propHeightPos',
            'propFontName',
            'maxCorner',
            'propFontSize',
            'propAutoSize',
            'propTextContent',
            'propIconName',
            'selectedShape',
            'zoom',
            'isOpenIconsModal',
            'isSidebarDropped',
            'cuttingOptions',
            'tutoEditor',
            'propCornerTopLeft',
            'propCornerTopRight',
            'propCornerBottomLeft',
            'propCornerBottomRight',
            'propCenterMarking',
            'materialName'
        ]),

        icon: function() {
            return this.icons.find(i => i.name == this.iconName);
        },

        categories: function() {
            let categories = [];

            if (this.icons && this.icons.length > 0) {
                let icons = this.icons.filter(i => i.active && i.categories.length > 1);
                icons.forEach(category => {
                    category.categories.forEach(catt => {
                        categories.push(catt);
                    });
                });
                categories = [...new Set(categories)];
            }

            return categories;
        },

        selectedProductImageUrl: function() {
            return this.$store.getters.productImg;
        },

        iconsOfCategory: function() {
            let list = [];

            if (this.icons && this.icons.length > 0) {
                list = this.icons.filter(i => !i.iscategory && i.categories.includes(this.selectedCategory) && i.active != false);
                if (this.selectedShape && this.selectedShape.isCut) {
                    list = list.filter(i => i.cuttable);
                }
            }

            return list;
        },
        title: function() {
            return this.titles[this.selectedShape.type];
        },
        availableFonts: function() {
            if (!this.fonts || this.selectedShape == null) return null;
            let type = this.selectedShape.isCut ? 'cut' : 'material';
            return this.fonts.filter(f => f.type == type && f.active);
        },

        drillingDiameters: function(){
            let drillingDiameter = Object.fromEntries(Object.entries(this.cuttingOptions).filter(([key]) => key.startsWith('drillingDiameter')));
            return drillingDiameter = Object.values(drillingDiameter).sort(function(a, b) {return a - b;});
        }
    },

    watch: {
        isOpenIconsModal: async function(iconModal) {
            if (this.iconModal != iconModal) this.iconModal = iconModal;
        },

        selectedShapeIds: async function(shapeIds) {
            if (shapeIds.length == 1) {
                this.initializeProperties(shapeIds[0]);
            } else {
                this.selectedShape = null;
            }
        },

        selectedShape: async function(selectedShape) {
            if (!selectedShape) {
                this.shapeId = null;
                this.$store.dispatch('setIsSidebarDropped', 'addtocart');
                this.$store.dispatch('setTuto', null);

                return;
            } else {
                this.tuto = null;
            }

            if (this.shapeId == selectedShape.id) return;

            this.shapeId = selectedShape.id;

            if (await PathUtils.gotInternalCut(this.selectedShape)) {
                this.notCuttable = true;
            } else {
                this.notCuttable = false;
            }

            this.oldTool = null;

            if (this.$store.getters.shapes.length != 1) this.$store.dispatch('setIsSidebarDropped', 'settings');
        },

        propRadius: async function(radius) {
            if (this.radius != radius){
                this.radius = radius;
                this.diameter = this.radius*2;
            } 
        },

        propRotation: async function(rotation) {
            if (this.rotation != Math.round(rotation)) this.rotation = Math.round(rotation);
        },

        propCorner: async function(corner) {
            if (this.corner != corner) this.corner = corner;
        },

        propPockets: async function(pockets) {
            if (this.pockets != pockets) this.pockets = pockets;
        },

        propPosition: async function(position) {
            if (this.positionX != position.x) this.positionX = position.x;
            if (this.positionY != position.y) this.positionY = position.y;
        },

        propSize: async function(size) {
            if (this.width != size.width) this.width = size.width;
            if (this.height != size.height) this.height = size.height;
        },

        propKeepProportions: async function(keepProportions) {
            if (this.keepProportions != keepProportions) this.keepProportions = keepProportions;
        },

        propHeightPos: async function(heightPos) {
            if (this.heightPos != heightPos) this.heightPos = heightPos;
        },

        propFontSize: async function(fontSize) {
            if (this.fontSize != fontSize) this.fontSize = fontSize;
        },

        propAutoSize: async function(autoSize) {
            if (this.autoSize != autoSize) this.autoSize = autoSize;
        },

        propTextContent: async function(content) {
            if (this.content != content) this.content = content;
        },

        propIconName: async function(iconName) {
            if (this.iconName != iconName) this.iconName = iconName;
        },

        propCornerTopLeft: async function(cornerTopLeft){
            if (this.cornerTopLeft != cornerTopLeft) this.cornerTopLeft = cornerTopLeft;
        },
        
        propCornerTopRight: async function(cornerTopRight){
            if (this.cornerTopRight != cornerTopRight) this.cornerTopRight = cornerTopRight;
        },

        propCornerBottomLeft: async function(cornerBottomLeft){
            if (this.cornerBottomLeft != cornerBottomLeft) this.cornerBottomLeft = cornerBottomLeft;
        },

        propCornerBottomRight: async function(cornerBottomRight){
            if (this.cornerBottomRight != cornerBottomRight) this.cornerBottomRight = cornerBottomRight;
        },

        propCenterMarking: async function(centerMarking){
            if(this.centerMarking != centerMarking) this.centerMarking = centerMarking;
        }
    },

    methods: {
        ...mapActions([
            'preventRepaint',
            'allowRepaint',
            'textFocus',
            'textBlur'
        ]),

        async refreshIcons() {
            let blockSize = 20;
            let response = await models.api.Icon.find({query: {$limit: blockSize}});
            this.icons = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Icon.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.icons = this.icons.concat(response.data);
            }
        },

        async refreshFonts() {
            let blockSize = 20;
            let response = await models.api.Font.find({query: {$limit: blockSize}});
            this.fonts = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Font.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.fonts = this.fonts.concat(response.data);
            }
        },
        async updateRadius(input) {
            this.$store.dispatch('setTuto', null);
            
            this.radius = this.diameter/2;
            if(this.radius < this.cuttingOptions.drillingThresholdDiameter/2){
                this.radius = ToolsUtils.drillingDiameter(this.radius, this.cuttingOptions.drillingThresholdDiameter/2, this.cuttingOptions);
                this.diameter = this.radius * 2;
                this.alertRadius = true;
                setTimeout(()=>{
                    this.alertRadius = false;
                }, 4000);
            }
            
            let radius = parseFloat(this.radius);
            let center = this.selectedShape.center;
            await this.$store.dispatch('setRadius', {radius, center});
            if(this.radius == this.cuttingOptions.drillingThresholdDiameter/2 && input == 'select') {
                document.getElementById("switchUpFocus").focus()
            }
        },

        async switchMarkingCenter(shape){
            this.$store.dispatch('setCenterMarking', !shape.centerMarking);
            let center = shape.center;
            let radius =0;
            if(shape.centerMarking){
                radius = this.cuttingOptions.centerMarkingDiameter; 
            }else{
                radius = this.cuttingOptions.drillingThresholdDiameter/2;
            }
            await this.$store.dispatch('setRadius', {radius, center});
            await shape.setCenterMarking(shape.centerMarking);
        },

        async updateRotation() {
            await this.$store.dispatch('setRotation', parseFloat(this.rotation));
        },

        async updateCorner() {
            await this.$store.dispatch('setCorner', parseFloat(this.corner));
        },

        async updateRoundCorner() {

            let max = this.maxCorner;
            let min = 0;
            this.cornerTopLeft = (this.cornerTopLeft > max)? max : (this.cornerTopLeft < 0)? min : parseFloat(this.cornerTopLeft);
            this.cornerTopRight = (this.cornerTopRight > max)? max : (this.cornerTopRight < 0)? min : parseFloat(this.cornerTopRight);
            this.cornerBottomLeft = (this.cornerBottomLeft > max)? max : (this.cornerBottomLeft < 0)? min : parseFloat(this.cornerBottomLeft);
            this.cornerBottomRight = (this.cornerBottomRight > max)? max : (this.cornerBottomRight < 0)? min : parseFloat(this.cornerBottomRight);
            var roundCorner = {"topLeft" : this.cornerTopLeft, "topRight" : this.cornerTopRight,  "bottomLeft" : this.cornerBottomLeft, "bottomRight" : this.cornerBottomRight};

                await this.$store.dispatch('setRoundCorner', roundCorner);
                await this.selectedShape.setRoundCorner(roundCorner);
                await this.$store.dispatch('setCorner', 0);
        },

        async switchCorner(){
            if(this.multipleCorner)
                await this.$store.dispatch('setCorner', 0);
            else 
                await this.$store.dispatch('setRoundCorner',{"topLeft" :0, "topRight" : 0,  "bottomLeft" : 0, "bottomRight" : 0});
        },

        async updatePockets(checked) {
            this.pockets = checked;
            await this.$store.dispatch('setPockets', this.pockets);
        },

        async updatePosition() {
            this.$store.dispatch('setTuto', null);
            await this.$store.dispatch('setPosition', {
                x: parseFloat(this.positionX),
                y: parseFloat(this.positionY)
            });
            this.$store.dispatch('setTuto', null);
        },

        async updateSize() {
            this.$store.dispatch('setTuto', null);
            let size = {
                width: parseFloat(this.width),
                height: parseFloat(this.height)
            };
            let center = this.selectedShape.center;
            await this.$store.dispatch('setSize', {size, center});
            this.$store.dispatch('setTuto', null);
        },

        async updateKeepProportions() {
            await this.$store.dispatch('setKeepProportions', this.keepProportions);
        },

        async updateHeightPos() {
            await this.$store.dispatch('setHeightPos', parseFloat(this.heightPos));
        },

        async updateFont(fontName) {
            await this.$store.dispatch('setFontName', fontName);
        },

        async updateFontSize() {
            await this.$store.dispatch('setFontSize', this.fontSize);
        },

        async updateAutoSize() {
            await this.$store.dispatch('setAutoSize', this.autoSize);
        },

        async updateContent() {
            await this.$store.dispatch('setTextContent', this.content);
        },

        async selectIcon(icon) {
            await this.$store.dispatch('setIconName', icon.name);

            if (this.selectedShape == null || this.selectedShape.type != 'materialsvg') {    
                this.$store.dispatch('setWhiteboardTool', 'svg');            
                this.$store.dispatch('setSvgPattern',icon.path);
                this.$store.dispatch('setSvgName',icon.name);
                paper.tools.find(t => t.name === 'svg').displayIcon();
            }

            this.$refs['icons-modal'].hide();
        },

        async removeShape(shape) {
           if(!shape.type.startsWith("cut")){
               if(await PathUtils.gotInternalCut(shape)) return false
           }
            if(shape.locked) return false;
            this.$store.dispatch('removeShapeId', shape.id);
            this.$store.dispatch('setSelectedShapes', []);
            this.$store.dispatch('setHeightPos', null);

            let selectionRectangle = paper.project.getItem({ name: "selection" });
            selectionRectangle.remove();

            paper.project.layers.selecter.removeChildren();
        },

        lockShape: function(shape) {
            shape.locked = !shape.locked;
            this.$store.dispatch('patchShape', shape);
            paper.tools.find(t => t.name === 'selecter').initSelectionRectangle()
        },

        cloneShape: function(shape) {
            if(shape.locked) return false;
            let clonedShape = shape.clone();
            this.$store.dispatch('addToolShape', clonedShape);
            clonedShape.move(new Point(shape.sizeW + 10, 0));
            
            let intersects = this.$store.getters.shapes.filter(shapes => shape.bounds.intersects(shapes.bounds) && shape.id != shapes.id && shapes.isCut && !shape.isCut);
            intersects.forEach(intersect => {
                let cutIntersectWithMatter = this.$store.getters.shapes.filter(shapes => intersect.bounds.intersects(shapes.bounds) && shape.id != shapes.id && !shapes.isCut);
                if(cutIntersectWithMatter.length == 0){
                    let cutClone = intersect.clone();
                    this.$store.dispatch('addToolShape', cutClone);
                    cutClone.move(new Point(shape.sizeW + 10, 0));
                }
            });

            PathUtils.zoomOnClone(shape,clonedShape);
        },

        centerOrigin: async function() {
            let shapes = this.$store.getters.shapes;
            let center = this.$store.getters.center;
            
            let selectedShapeBounds = this.selectedShape.bounds;
            let selectedShapes = [this.selectedShape];

            //S'il s'agit d'une découpe interne, on check de quelle shape elle dépends pour sélectionner cette dernière et en définir l'origine
            if(this.selectedShape.isCut){
                shapes.forEach(element => {
                    if(element.id != this.selectedShape.id && element.bounds.intersects(selectedShapeBounds)){
                        selectedShapes.push(element);
                    }
                });
            }

            //Ici on déselectionne la forme sur laquelle on a cliqué au début pour sélectionner son groupe si c'est une découpe interne (interne + parent)
            paper.tools.find(t => t.name === 'selecter').deselect();
            await this.$store.dispatch('setSelectedShapes', selectedShapes);
            paper.tools.find(t => t.name === 'selecter').select(selectedShapes);

            //On défini le coin bas gauche de la pièce pour en faire l'origine du plan, la première itération étant toujours le parent si il y a des découpes internes, sinon c'est juste la pièce sélectionnée 
            let pieceOriginCorner = paper.project.selectedItems[0].bounds.bottomLeft;
            let shapeOrigin = pieceOriginCorner.multiply(-1);

            shapes.forEach(element => {
                    element.move(shapeOrigin);
            });

            center = center.add(shapeOrigin);
            await this.$store.dispatch('patchShapes',shapes);
            await this.$store.dispatch('setCenter',center);
            await this.$store.dispatch('setSelectedShapes', selectedShapes);
            paper.tools.find(t => t.name === 'selecter').initSelectionRectangle();
        },

        hideModal() {
            this.$refs['icons-modal'].hide();
            this.$store.dispatch('openIconsChoice', false);
        },

        openIconsModal() {
            if (this.isOpenIconsModal) {
                this.$store.dispatch('openIconsChoice', false);
            } else {
                this.$store.dispatch('openIconsChoice', true);
            }
        },

        setSidebarDropped(element) {
            if (document.getElementById('switch-settings').className.indexOf('opa-5') == -1 && this.isSidebarDropped != element) {
                this.$store.dispatch('setIsSidebarDropped', element);
            } else {
                this.$store.dispatch('setIsSidebarDropped', 'addtocart');
            }
            if (document.getElementById('switch-settings').className.indexOf('opa-5') >= 1) {
                if (this.tuto == "settings") {
                    this.tuto = null;
                } else {
                    this.tuto = "settings";
                }
            }
        },

        tutorial(element) {
            if (this.tuto != element) {
                this.tuto = element;
            } else {
                this.tuto = null;
            }
        },

        unFocus() {
            document.querySelectorAll('.propertiesBox input').forEach(function(e) {
                e.blur();
            });
        },
    },
    created() {
        this.updateRadius = debounce(this.updateRadius, 500);
    }
}
</script>


<style lang="scss">
    @import '../../assets/slider.css';
    @import './../../assets/scss/_variables.scss';

    .propertiesBox {
        #not-cuttable:after {
            left: 30px;
        }

        input {
            border: 3px solid $grispro;
            border-radius: 10px;
            padding: 5px 15px;
            width: inherit;

            &:focus {
                outline: none;
            }
        }

        .vs__dropdown-toggle {
            border: 3px solid $grispro;
            border-radius: 10px;
            padding: 5px 0;
        }

        .vs__selected {
            position: relative!important;
        }

        svg {
            transition: all .3s ease-in-out;
        }

        .indicator {
            position: absolute;
            right: 10px;
            top: 7px;
            font-weight: bold;
        }

        .bi-info-circle-fill {
            fill: transparent;
            stroke: $jaune;
            cursor: pointer;
            margin-top: -10px;

            @media (pointer: fine) {
                &:hover {
                    transform: scale(1.3) rotate(15deg);
                }
            }
        }

        #move:hover {
            svg.bi-arrows-move {
                animation-name: move;
                animation-duration: .8s;
            }
        }

        #resize,
        #resize-radius {
            &:hover {
                .cls-1 {
                    animation-name: resize-one;
                    animation-duration: .5s;
                }
                .cls-2 {
                    animation-name: resize-two;
                    animation-duration: .5s;
                }
            }
        }

        #resize {
            select {
                border: 3px solid #f3f3f3;
                border-radius: 10px;
                padding: 5px 15px;
                width: inherit;
                outline : none;
            }
        }

        #resize.tuto,
        #move.tuto {
            input {
                animation-name: breathe-input;
                animation-duration: 3s;
                animation-iteration-count: infinite;
                animation-delay: 1s;
            }
        }

        #rotate:hover svg.rotate {
            transform: rotate(-200deg);
        }

        #text:hover {
            .text-1 {
                animation-name: text-1;
                animation-duration: .8s;
            }
            .text-2 {
                animation-name: text-2;
                animation-duration: .8s;
            }
            .text-3 {
                animation-name: text-3;
                animation-duration: .8s;
            }
        }

        .rect {
            width: 19px;
            height: 19px;
            border-radius: 2px;
            border: 3px solid #343a40;
        }

        #round-corners {
            #rect {
                transition: all .3s ease-in-out;
                
            }

            &:hover {
                #rect {
                    border-radius: 8px;
                }
            }
        }

        #round-corners-advanced {
            #rect-top-left {
                border-radius: 15px 0 0 0;
            }
            #rect-top-right {
                border-radius: 0 15px 0 0;
            }
            #rect-bottom-left {
                border-radius: 0 0 0 15px;
            }
            #rect-bottom-right {
                border-radius: 0 0 15px 0;
            }
        }

        #triangle {
            svg {
                overflow: visible;

                * {
                    transition: none!important;
                }
            }
        }

        #shape {
            .rounded-left-10 {
                background: $grispro;
                border: 3px solid $gris;
            }
            svg {
                fill: $jaune;
                stroke: $dark;
                stroke-width: 1px;
            }
        }

        #button-setting {
            button {
                &:hover {
                    transform: scale(1.02);
                    box-shadow: 0 10px 20px -10px rgb(179 178 178 / 75%);
                }
            }

            .bi-info-circle-fill {
                z-index: 10;
                position: absolute;
                top: 18px;
                right: 8px;
            }
        }

        #pockets {
            circle {
                transition: all .3s ease-in-out;
            }

            &:hover {
                circle:nth-child(2) {
                    transform: translate(5px,5px);
                }
                circle:nth-child(3) {
                    transform: translate(5px,-5px);
                }
                circle:nth-child(4) {
                    transform: translate(-5px,-5px);
                }
                circle:nth-child(5) {
                    transform: translate(-5px,5px);
                }
            }

            .custom-control-label {
                cursor: pointer;
            }

            .bi-info-circle-fill {
                top: 10px;
                right: -24px;
            }
        }

        #clone {
            svg {
                height: 34px;
            }
            &:not(.disabled):hover {
                svg {
                    .cls-1 {
                        transform: translate(5px, -5px);
                        stroke-dasharray: 0;
                        fill: $jaune;
                    }
                    .cls-2 {
                        transform: translate(-5px, 5px);
                        fill: $jaune;
                    }
                }
            }
        }

        #recenter {
            svg {
                overflow: visible;
                height: 28px;
            }
            &:hover {
                line,
                polygon {
                    transform: translate(58px, -58px);
                }
            }
        }

        #remove {
            svg {
                overflow: inherit!important;
                height: 27px;
            }
            &:not(.disabled):hover {
                rect {
                    transform: rotate(45deg);
                    transform-origin: right;
                }
                svg * {
                    fill: $jaune;
                }
            }
            &.disabled:hover {
                cursor: not-allowed;

                .fly-over {
                    display: none;
                }
            }
        }

        #lock {
            svg {
                overflow: inherit!important;
                height: 25px;
            }

            .unlocked {
                .cls-1 {
                    transform: translate(-60px, -85px);
                }
            }

            &:hover {
                .locked {
                    .cls-1 {
                        animation: .8s linear infinite alternate unlock;
                    }
                }
                .unlocked {
                    .cls-1 {
                        animation: .8s linear infinite alternate lock;
                    }
                }

                svg {
                    rect {
                        fill: $jaune;
                    }
                    circle {
                        fill: $dark;
                    }
                    path:last-child {
                        fill: $dark;
                    }
                }
            }
        }

        #switch-settings {
            transition: all .3s ease-in-out;
            background-position: 0 -50px;
            border-radius: 10px;
            background: #a39797;
            position: relative;
            z-index: 10;

            &.active {
                background: $rose!important;
                border-radius: 10px 10px 0 0;
                cursor: pointer;

                span {
                    font-weight: bold;
                }
            }
        }

        #settings-sidebar {
            div:nth-child(2) {
                animation-delay: .05s;
            }
            div:nth-child(3) {
                animation-delay: .1s;
            }
            div:nth-child(4) {
                animation-delay: .15s;
            }
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
        -webkit-appearance: none;
            margin: 0;
        }

        input[type=number] {
            -moz-appearance: textfield;
        }

        svg * {
            transition: all .3s ease-in-out;
        }

        input {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
        }
    }

    .toplevel {
        input {
            display: none;
        }
    }

    #setting-tools {
        background: #e6e9f0;
        position: relative;
        z-index: 10;

        svg {
            transition: all .3s ease-in-out;
        }

        .tool {
            width: 66px;
            transition: all .3s ease-in-out;

            &.active {
                box-shadow: 0 10px 20px -10px rgb(179 178 178 / 75%);
                border-bottom: 4px solid #e83c69;
            }

            &:hover:not(.active) {
                .fly-over {
                    display: block;
                    opacity: 1;
                }
            }
        }

        .btn-lg {
            padding: 0;
            border: 0;
            background-color: transparent;
            box-shadow: none!important;
        }
    }

    #action-setting {
        .tool{
            @media (pointer: fine) {
                &:hover {
                    .fly-over {
                        display: block;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .fly-over {
        transition: all .3s ease-in-out;
        transition-delay: .4s;
        position: absolute;
        top: -45px;
        z-index: 10;
        background: #e6e9f0;
        font-weight: bold;
        padding: 5px 10px;
        border-radius: 10px;
        white-space: nowrap;
        display: none;

        &:after {
            position: absolute;
            content: "";
            width: 0px;
            height: 0px;
            border-top: 15px solid #e6e9f0;
            border-right: 15px solid transparent;
            border-bottom: 15px solid transparent;
            border-left: 15px solid transparent;
            bottom: -25px;
            right: 0;
            left: 0;
            margin: auto;
        }
    }

    /* The sidebar menu */
    .icons {
        .icon {
            padding: 1em;
            background-color: #eee;
            margin: 0.5em;
            border: 2px solid #ddd;
        }
    }

    #icons-modal header {
        border-bottom: 0;
        padding: 0;

        .close {
            background: white;
            opacity: 1;
            color: $rose;
            border-radius: 50%;
            float: none;
            margin: 0;
            padding: 2px 7px;
            border: 3px solid $rose;
        }
    }

    #category-choice {
        padding-top: 25px;
        width: 80%;
        margin: 0 auto;
        border-top: 1px solid white;
    }

    .icon {
        background: transparent!important;
        border: 0;
        transition: all .1s ease-in-out;

        &:hover {
            transform: scale(1.02);
            .icon-svg {
                box-shadow: 0 10px 20px -10px rgb(179 178 178 / 75%);
            }
        }

        div {
            // border: 2px solid $gris;
            border-radius: 10px;
        }

        svg {
            fill: $gris;
        }
    }

    .one-category {
        .active {
            background: $jaune;
            color: $dark!important;
            padding: 0 7px;
        }
    }

    .icon-svg {
        border: 3px solid $grispro;
    }

    .opa-5 {
        opacity: .5!important;
        cursor: not-allowed!important;
    }

    #autosize {
        .switch {
            border: 2px solid $grispro;
            border-radius: 10px;
            width: 85px;

            span {
                font-size: 70%;
                font-weight: bold;
            }

            &.active {
                background: $jaune;
                border: 0;
            }
        }
    }

    #input {
        height: 40px;
    }

    .fly-over-setting:after {
        content: "";
        width: 0px;
        height: 0px;
        border-top: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 15px solid $grispro;
        border-left: 15px solid transparent;
        top: -25px;
        left: 12px;
        position: absolute;
    }

    #button-setting {
        .fly-over-setting:after {
            display: none;
        }
    }

    #radius-resize {
        top: 0;
        right: 0;
        
        button {
            position: relative;
            z-index: 2;
        }
    }

    .input-number {
        input {
            z-index: 2;
            position: relative;
            background: transparent!important;
        }

        .suffix-detail {
            position: absolute;
            z-index: 1;
            top: 3px;
            left: 3px;
            padding: 5px 15px;

            span {
                opacity: 0;
            }

            .suffix {
                opacity: 1;
                font-size: 80%;
            }

            &.degrees {
                top: -2px;
                left: -1px;

                .suffix {
                    font-size: 130%;
                }
            }
        }
    }

    @keyframes resize-one {
        0%, 33% {
            transform: translate(-15px, -68.5px);
        }

        33%, 66% {
            transform: translate(-27px, -53.5px);
        }

        66%, 100% {
            transform: translate(-15px, -68.5px);
        }
    }

    @keyframes resize-two {
        0%, 33% {
            transform: translate(-15px, -68.5px);
        }

        33%, 66% {
            transform: translate(-3px, -80px);
        }

        66%, 100% {
            transform: translate(-15px, -68.5px);
        }
    }

    @keyframes move {
        0%, 20% {
            transform: translate(0);
        }

        20%, 40% {
            transform: translate(5px);
        }

        40%, 60% {
            transform: translate(-5px, -5px);
        }

        60%, 80% {
            transform: translate(-5px, 5px);
        }

        80%, 100% {
            transform: translate(0);
        }
    }

    @keyframes text-1 {
        0%, 33% {
            opacity: 1;
        }

        33%, 66% {
            opacity: 0;
        }

        66%, 100% {
            opacity: 0;
        }
    }
    @keyframes text-2 {
        0%, 33% {
            opacity: 0;
        }

        33%, 66% {
            opacity: 1;
        }

        66%, 100% {
            opacity: 0;
        }
    }
    @keyframes text-3 {
        0%, 33% {
            opacity: 0;
        }

        33%, 66% {
            opacity: 0;
        }

        66%, 100% {
            opacity: 1;
        }
    }
     @keyframes unlock {
        33%, 66% {
            transform: translate(-60px, -35px)
        }

        66%, 100% {
            transform: translate(-60px, -85px)
        }
    }
    @keyframes lock {
        0%, 33% {
            transform: translate(-60px, -85px)
        }

        33%, 66% {
            transform: translate(-60px, -35px)
        }

        66%, 100% {
            transform: translate(-60px, -55px)
        }
    }

    @keyframes breathe-input { 
        0% { border: 3px solid #f3f3f3; } 
        25% {  
            border: 3px solid #ffb400; 
            transform: scale(1.04); } 
        60% { border: 3px solid #f3f3f3; } 
        100% { border: 3px solid #f3f3f3; } 
    }

    .bounce-enter-active {
        transition: all .8s ease-in-out;
        max-height: 1000px;
    }
    .bounce-leave-active {
        transition: all .5s ease-in-out;
        max-height: 1000px;
    }
    .bounce-enter, .bounce-leave-to {
        transform: translateY(10px);
        opacity: 0;
        max-height: 0px;
    }

    :root {
        --animate-delay: 0!important;
    }

    .disabled{
        opacity: 0.5;
    }

    #alertRadius {
        border: 2px solid $rose;

        svg {
            fill: $rose;
            stroke: $white;
        }
    }
</style>
